module.exports = __webpack_public_path__ + "img/banchetto-martello.6df73382.jpg";